import CommentMarker from './CommentMarker';
import ReferenceMarker from './ReferenceMarker';
import TaskMarker from './TaskMarker';
import SuggestionMarker from './SuggestionMarker';

export const markerComponentByType = {
    comment: CommentMarker,
    reference: ReferenceMarker,
    task: TaskMarker,
    insertion: SuggestionMarker,
    deletion: SuggestionMarker,
    change: SuggestionMarker,
};

export function getMarkerTop(marker) {
    const top = marker?.packedTopPx ?? marker?.topPx;
    return Number.isFinite(top) ? top : null;
}

